import * as React from 'react';
import { IconBase } from './icon-base.js';
export function Flag(iconProps) {
    return (React.createElement(IconBase, { name: 'flag', ...iconProps, render: ({ title, titleId, color, width, height, ...props }) => (React.createElement("svg", { width: width, height: height, viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', color: color, "aria-labelledby": titleId, ...props },
            title ? React.createElement("title", { id: titleId }, title) : null,
            React.createElement("path", { d: 'M2.5 13.5V3H14L11 6.75L14 10.5H2.5', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' }))) }));
}
